import { toBase64, getImageDimension } from "@/domain/system/files";

const state = {
  files: [],
  indexSelectedFile: -1
};

const getters = {
  getSelectedFile(state) {
    if (
      state.indexSelectedFile > -1 &&
      state.indexSelectedFile < state.files.length
    ) {
      return state.files[state.indexSelectedFile];
    }
    return false;
  }
};

const actions = {
  async uploadFilesToStorage({ commit }, files) {
    for (let i = 0; i < files.length; i++) {
      let result = {
        file: files[i],
        src: undefined,
        dimension: {
          width: undefined,
          height: undefined
        }
      };
      result.src = await toBase64(files[i]);
      result.dimension = await getImageDimension(files[i]);
      commit("appendFiles", result);
    }
  }
};

const mutations = {
  appendFiles(state, fileStore) {
    state.files.push(fileStore);
  },
  selectFile(state, index) {
    state.indexSelectedFile = index;
  },
  clearFileUploader(state) {
    state.files = [];
    state.indexSelectedFile = -1;
  },
  setNextFile(state) {
    if (
      state.indexSelectedFile > -1 &&
      state.files.length > state.indexSelectedFile
    ) {
      state.files.splice(state.indexSelectedFile, 1);
      if (state.files.length <= state.indexSelectedFile) {
        state.indexSelectedFile = state.files.length - 1;
      }
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
